import api from '../../utils/api'

import { useEffect, useState } from 'react'



/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormSimpleProduct from './Form/FormSimpleProduct'

function EditSimpleProduct({id , btCancelAction, handleOnSuccess}){
    const [simpleProduct, setSimpleProduct] = useState({})

    const [token] = useState(localStorage.getItem('token') || '')

    const {setFlashMessage} = useFlashMessage()


    useEffect(() => {

        api.get(`/simpleProduct/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {


            setSimpleProduct(response.data.simpleProduct)
        })
    }, [token, id])


    async function updateSimpleProduct(simpleProduct) {
        let msgType = 'success'


        const data = await api.patch(`simpleProduct/update/${simpleProduct._id}`, simpleProduct, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {

            return response.data
        }).catch((err) => {

            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()

            }

    }


    return (
        simpleProduct.description && (
            <FormSimpleProduct title="Editar Produto" handleSubmit={updateSimpleProduct} btnText="Salvar" btCancelAction={btCancelAction} simpleProductData={simpleProduct} />
        )
    )
}

export default EditSimpleProduct
